module.exports = __webpack_public_path__ + "static/media/refund-icon-big.6e510416.svg";